<template>
  <span v-if="helpUrl" class="fa fa-circle-info help-link" @click="openUrl(helpUrl)" :title="helpTooltip"
    data-bs-toggle="tooltip" data-bs-placement="right"></span>
</template>

<script>
export default {
  name: 'HelpIcon',
  computed: {
    helpUrl() {
      const currentRouteName = this.$route.name;
      const docLinks = this.$store.state.admin.docLinks || [];
      const matchingDocLink = docLinks.find(link => link.route_name === currentRouteName);
      return matchingDocLink ? matchingDocLink.url : null;
    },
    helpTooltip() {
      const currentRouteName = this.$route.name;
      const docLinks = this.$store.state.admin.docLinks || [];
      const matchingDocLink = docLinks.find(link => link.route_name === currentRouteName);
      return matchingDocLink ? `Help for ${matchingDocLink.title}` : 'Knowledge Base';
    }
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
.help-link {
  position: absolute;
  top: -2px;
  right: -25px;
  color: #6e84a3 !important;
  font-size: 16px;
  cursor: pointer;
}

.help-link:hover {
  color: #5a6c7d !important;
}
</style>
